import Slider from '../classes/SliderClass';

const selectors = {
    el: '.js-slider:not(.is-initialized)',
};

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');
        new Slider(el);
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;
